import { render, staticRenderFns } from "./saleReport.vue?vue&type=template&id=2b4fa511"
import script from "./saleReport.vue?vue&type=script&lang=js"
export * from "./saleReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports